<template>
  <b-row>
    <b-col>
      <b-row v-if="title">
        <b-col>
          <h5 class="text-center">{{ title }}</h5>
          <hr/>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <select-button-form
            :label="select.label"
            :addLabel="select.addLabel"
            :prefix="select.prefix"
            :attr="select.attr"
            :model="select.model"
            :map="select.map"
            @submit="showModal"
          >
        </select-button-form>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <list-summary
            :list="summaryList"
            @item-clicked="item => $emit('item-clicked', item)"
          >
          </list-summary>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-modal
            ref="addModal"
            hide-footer
            header-class="anchor-modal"
            no-close-on-backdrop
            :title="modalTitle"
          >
            <slot></slot>
          </b-modal>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>


<script>
import ListSummary from '@/components/profile/sections/tabs/financial/ListSummary';
import SelectButtonForm from '@/components/utils/selects/select_button_form/SelectButtonForm';

export default {
  components: {
    ListSummary,
    SelectButtonForm,
  },
  props: {
    select: {
      type: Object,
      required: true,
    },
    items: {
      type: Object,
      required: true,
    },
    itemKeys: {
      type: Object,
      default() { return {}; },
    },
    itemsMap: {
      type: Object,
      required: true,
    },
    title: String,
  },
  computed: {
    modalTitle() {
      const type = this.select.model[this.select.attr];
      return type ? this.select.map[type] : 'New Item';
    },
    summaryList() {
      if (!this.items) { return []; }

      return Object.keys(this.items).map((key) => {
        const attr = this.itemKeys[key] || 'amount';
        const reduce = this.items[key].reduce(
          (acc, next) => ({ [attr]: parseFloat(acc[attr]) + parseFloat(next[attr]) }),
          { [attr]: 0 },
        );
        const total = reduce[attr];

        return {
          id: key,
          text: this.itemsMap[key],
          value: total,
        };
      });
    },
  },
  methods: {
    showModal() {
      this.$refs.addModal.show();
    },
    hideModal() {
      this.$refs.addModal.hide();
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hide', () => {
      if (this.$refs.addModal) {
        this.$emit('hide-modal');
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/financial/SelectForm.vue